import { call } from 'redux-saga/effects';

import { DEPENDENT_FORM_STEPS } from '../progress.actions';
import { sendPersonalInfo } from './send-personal-info-saga';
import { sendGeneralInfo } from './send-genera-info-saga';
import { sendDocuments } from './send-documents-saga';
import { sendRelation } from './send-relation-saga';
import { setRole } from './set-role-saga';

export function* handleNext({ payload: { step, data } }) {
  switch (step) {
    case DEPENDENT_FORM_STEPS.ROLE: {
      yield call(setRole, data);
      break;
    }

    case DEPENDENT_FORM_STEPS.PERSONAL: {
      yield call(sendPersonalInfo, data);
      break;
    }

    case DEPENDENT_FORM_STEPS.GENERAL: {
      yield call(sendGeneralInfo, data);
      break;
    }

    case DEPENDENT_FORM_STEPS.DOCUMENTS: {
      yield call(sendDocuments, data);
      break;
    }

    case DEPENDENT_FORM_STEPS.RELATION: {
      yield call(sendRelation, data);
      break;
    }

    default: {
      break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/next-navigation-saga.js